package com.milta.feature.route.presentation

/** User intents for MIL-52 "Historique des preuves de livraison" (both screens, see [WebHistoriqueState] doc). */
sealed interface WebHistoriqueIntent {
    /** Initial load — resolves the enterprise's driver list once (dropdown filter) and loads
     * Screen A's page 1 with the default filters. */
    data object Load : WebHistoriqueIntent

    data class SelectPeriodMode(val mode: HistoriquePeriodMode) : WebHistoriqueIntent
    data class SelectSingleDate(val date: String) : WebHistoriqueIntent
    data class SelectRangeFrom(val date: String) : WebHistoriqueIntent
    data class SelectRangeTo(val date: String) : WebHistoriqueIntent

    /** Null selects "Tous les livreurs". */
    data class SelectDriver(val driverId: String?) : WebHistoriqueIntent

    data class GoToHistoryPage(val page: Int) : WebHistoriqueIntent

    /** Screen A → Screen B — "Voir les preuves" action / row click. */
    data class OpenRouteProofs(val routeId: String) : WebHistoriqueIntent

    /** Screen B → Screen A — "← Historique des tournées" back link. Screen A's filters and current
     * page are left untouched (see [WebHistoriqueState] doc) — only Screen B's own state is cleared. */
    data object BackToHistory : WebHistoriqueIntent

    data class GoToProofsPage(val page: Int) : WebHistoriqueIntent
}
